<div>
  <form nz-form [formGroup]="welllogForm" (ngSubmit)="submitForm()" class="form-container">
    <div nz-row [nzGutter]="24">
      <div nz-col [nzXs]="24" [nzSm]="12">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="name">Name</nz-form-label>
          <nz-form-control nzErrorTip="The input required!">
            <input placeholder="Well log name" nz-input formControlName="name" id="name" />
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col [nzXs]="24" [nzSm]="12">
        <nz-form-item>
          <nz-form-label nzFor="description">Description</nz-form-label>
          <nz-form-control>
            <input placeholder="Well log description" nz-input formControlName="description" id="description" />
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <nz-form-item>
      <nz-form-label nzRequired nzFor="log_file_path">Well Log Path</nz-form-label>
      <nz-form-control [nzSm]="24" [nzXs]="24" nzErrorTip="The input is not valid Well Log Path!">
        <input placeholder="Well log file path" nz-input formControlName="log_file_path" id="log_file_path" />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label nzFor="markers_file_path">Well Markers Path</nz-form-label>
      <nz-form-control [nzSm]="24" [nzXs]="24" nzErrorTip="The input is not valid Well Marker Path!">
        <input placeholder="Well Markers file path" nz-input formControlName="markers_file_path" id="markers_file_path" />
      </nz-form-control>
    </nz-form-item>

    <div nz-row [nzGutter]="24">
      <div nz-col [nzXs]="12" [nzSm]="12">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="inline_location">Inline Location</nz-form-label>
          <nz-form-control nzErrorTip="The input is not Inline Location!">
            <nz-input-number nzPlaceHolder="Inline Location of Well" style="width: 100%" nzMin="1"
              formControlName="inline_location" id="inline_location"></nz-input-number>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col [nzXs]="12" [nzSm]="12">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="crossline_location">Crossline Location</nz-form-label>
          <nz-form-control nzErrorTip="The input is not Crossline Location!">
            <nz-input-number nzPlaceHolder="Crossline Location of Well" style="width: 100%" nzMin="1"
              formControlName="crossline_location" id="crossline_location"></nz-input-number>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div style="
        display: flex;
        gap: 10px;
        justify-content: flex-end;
        margin-bottom: 15px;
      ">
      <button type="reset" (click)="resetForm()" nz-button>Reset</button>
      <button nzType="primary" type="submit" nz-button>Submit</button>
    </div>
  </form>
</div>

<div class="table-scroll-wrapper">
  <nz-table id="listing-table" class="styled-table" #welllogsTable [nzData]="wellLogs">
    <thead>
      <tr>
        <th>Name</th>
        <th>Description</th>
        <th>Log File Path</th>
        <th>Markers File Path</th>
        <th>Inline Location</th>
        <th>Crossline Location</th>
        <th [nzWidth]="150">Action</th>
      </tr>
    </thead>
    <tbody>
      @for (data of welllogsTable.data; track data) {
      <tr>
        <td>{{ data.name }}</td>
        <td>{{ data.description }}</td>
        <td>{{ data.log_file_path }}</td>
        <td>{{ data.markers_file_path }}</td>
        <td [width]="150">{{ data.inline_location / dx + 1 }}</td>
        <td [width]="150">{{ data.crossline_location / dx + 1 }}</td>
        <td [width]="150">
          <a (click)="editWellLog(data)">Edit</a>
          <nz-divider nzType="vertical"></nz-divider>
          <a (click)="deleteWellLog(data)">Delete</a>
        </td>
      </tr>
      }
    </tbody>
  </nz-table>
</div>